module.exports = __webpack_public_path__ + "img/8459c8bad50364554910a5bb749122b3.png";